import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { localeFromPublicPathname } from '../i18n/config';

/** 公開 URL のロケール（パス正本。i18n の navigator/localStorage より優先）。 */
export function usePublicPathLocale(): string {
  const { i18n } = useTranslation();
  const location = useLocation();
  return localeFromPublicPathname(location.pathname) || i18n.language;
}
